import React, { useState } from 'react';
import { Select, Button, Space, message } from 'antd';
import stc from 'string-to-color';
import { useEffect } from 'react';
import { useGetAllCompanyCode } from '../../hooks/useSignup';
import { useUpdateClientAcl } from '../../hooks/useUserAclComponent';
import CommonTable from '../../commonComponents/Table/table';

const EditAclClient = props => {
    const [clientData, setClientData] = useState([]);
    const [isCompanyList, setIsCompanyList] = useState(false);
    const [companyCodeText, setCompanyCodeText] = useState('');
    const { data: companyCodeList } = useGetAllCompanyCode();

    const onGetSuccessAclClient = async resp => {
        if (resp.status === 200) {
            props.setIsModalAcl(false);
            await props.fetchUserListing();
            message.success('Updated Successfully');
        }
    };
    const { mutate: updateClientAcl } = useUpdateClientAcl(onGetSuccessAclClient);

    useEffect(() => {
        if (props?.data) {
            setClientData(props?.data);
        }
    }, []);
    console.log(clientData, 'companyCodeList');

    const handleRemoveAclClient = id => {
        let items = [...clientData];
        let filteredItems = items?.filter(item => item?._id !== id);
        setClientData(filteredItems);
    };

    const addDataToACl = data => {
        if (clientData.includes(data)) {
            message.info('Already added');
        } else {
            setClientData([...clientData, data]);
            // message.success('Added Successfully');
        }
    };

    console.log(clientData, 'clientData');

    const updateAcl = () => {
        let payload = {
            aclType: 'clients',
            updateData: clientData,
            targetUserId: props?.targetId,
        };
        updateClientAcl(payload);
    };

    const InnerTableCols = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Action',
            key: 'key',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => handleRemoveAclClient(record?._id)} type="primary" danger>
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <>
            <div className="form-table">
                <div>
                    <CommonTable columns={InnerTableCols} data={clientData} bordered height={'calc(100vh - 463px)'} overflow={'auto'} />
                </div>
            </div>

            {isCompanyList && (
                <Select showSearch placeholder="Select company code" className="select-parent" value={companyCodeText}>
                    {companyCodeList?.data
                        ?.filter(item => !clientData.map(item => item.code).includes(item.code))
                        .map(el => {
                            return (
                                <Select.Option key={el._id} value={el.code}>
                                    <div className="select-list" style={{}} onClick={() => addDataToACl(el)}>
                                        <div
                                            style={{
                                                backgroundColor: stc(el.code),
                                                width: '5px',
                                                height: '15px',
                                                marginRight: '5px',
                                            }}
                                        ></div>
                                        <span>{el.code}</span>
                                    </div>
                                </Select.Option>
                            );
                        })}
                </Select>
            )}
            <div className="p-2">
                <Button onClick={() => setIsCompanyList(true)}>+ Add more</Button>
            </div>
            <div className="table-footer">
                <Button type="primary" onClick={() => updateAcl()}>
                    Update
                </Button>
                <Button type="default" onClick={() => props.setIsModalAcl(false)}>
                    Cancel
                </Button>
            </div>
        </>
    );
};

export default EditAclClient;
